module.exports = __webpack_public_path__ + "static/img/section4.4732a4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/section4.png
// module id = O4/E
// module chunks = 1